import React, { FC, ReactElement, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthenticatedTemplate } from "@azure/msal-react";
import Loader from "./components/Loader";

// Lazy-loaded components
const Header = lazy(() => import("./components/Header"));
const GlobalNav = lazy(() => import("./components/GlobalNav"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const AddAgentPage = lazy(() => import("./pages/AddAgents"));
const AgentDetailPage = lazy(() => import("./components/AgentDetailPage"));
const Admin = lazy(() => import("./pages/Admin"));
const ProtectedRoute = lazy(() => import("./components/ProtectedRoute"));
const NoAccess = lazy(() => import("./components/NoAccess"));
const AgentRequest = lazy(() => import("./components/AgentRequest"));
const SnackbarError = lazy(() => import("./components/SnackbarError"));
const SnackbarSuccess = lazy(() => import("./components/SnackbarSuccess"));
const AdminRoute = lazy(() => import("./components/AdminRoute"));

const App: FC<any> = (): ReactElement => {
  return (
    <Router>
      <div className="w-screen h-screen overflow-hidden bg-background pt-[52px] px-0 sm:px-4 md:pl-12 md:pr-4 lg:px-12 relative">
        <div
          className="min-h-screen relative overflow-x-hidden"
          style={{
            background:
              "linear-gradient(to bottom right, #0E2347,#001437, #FD5F07)",
          }}
        >
          {/* Persistent Layout */}
          <Suspense fallback={<Loader />}>
            <Header />
            <GlobalNav />
          </Suspense>

          {/* Route Content */}
          <div className="content">
            <Suspense
              fallback={
                <div className="absolute top-0 left-0 w-full h-full z-10 bg-[#FBFBFB] flex items-center justify-center">
                  <Loader />
                </div>
              }
            >
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route
                  path="/agentdetail/:agentId"
                  element={<AgentDetailPage />}
                />
                <Route path="/add-agent" element={<AddAgentPage />} />
                <Route path="/edit-agent/:agentId" element={<AddAgentPage />} />

                <Route
                  path="/admin"
                  element={
                    <AuthenticatedTemplate>
                      <AdminRoute>
                        <Admin />
                      </AdminRoute>
                    </AuthenticatedTemplate>
                  }
                />
                <Route
                  path="/agent/:id"
                  element={
                    <AuthenticatedTemplate>
                      <ProtectedRoute>
                        <AgentRequest />
                      </ProtectedRoute>
                    </AuthenticatedTemplate>
                  }
                />
                <Route path="/noaccess" element={<NoAccess />} />
              </Routes>
            </Suspense>
          </div>

          {/* Global Snackbars */}
          <Suspense fallback={null}>
            <SnackbarError />
            <SnackbarSuccess />
          </Suspense>
        </div>
      </div>
    </Router>
  );
};

export default App;
